import { render, staticRenderFns } from "./ManageEmailBlacklist.vue?vue&type=template&id=4c23e7ac"
import script from "./ManageEmailBlacklist.vue?vue&type=script&lang=js"
export * from "./ManageEmailBlacklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports